import { render, staticRenderFns } from "./Authority.vue?vue&type=template&id=17ef9520&scoped=true&"
import script from "./Authority.vue?vue&type=script&lang=js&"
export * from "./Authority.vue?vue&type=script&lang=js&"
import style0 from "./Authority.vue?vue&type=style&index=0&id=17ef9520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef9520",
  null
  
)

export default component.exports